import type { Faq, Insight, Office, TeamMember } from '../types/content'

export const contact = {
  phonePrimary: '0710 894 206',
  phoneSecondary: '066 321700',
  email: 'info@premieradvisory.co.ke',
  website: 'premieradvisory.co.ke',
}

export const offices: Office[] = [
  {
    label: 'Head Office — Nairobi',
    address: 'Azure Towers, 3rd Floor, Rhapta Road, Westlands',
    box: 'P.O Box 10624-00100',
  },
  {
    label: 'Branch — Nanyuki',
    address: 'Odyssey Building, Opp. Cedar Mall, Laikipia Road',
    box: 'P.O Box 201-10400',
  },
  {
    label: 'Branch — Nakuru',
    address: 'Lydia Arcade, Kenyatta Avenue',
    box: 'P.O Box 201-20100',
  },
]

export const photos = {
  boardroom:
    'https://cdn.magicpatterns.com/uploads/wtSrwi7z1CvtyJxvU6MMkG/business-colleagues-meeting-and-brainstorming-toge-2026-03-18-10-53-08-utc.jpg',
  deskPair:
    'https://cdn.magicpatterns.com/uploads/uRkeoP4jmdGTtAcf4p9z7Z/two-laughing-young-black-people-have-fun-discussin-2026-01-08-05-16-13-utc.jpg',
  reviewing:
    'https://cdn.magicpatterns.com/uploads/2xFhA1dWsBQLWxHGKg8SuZ/two-young-african-american-professionals-reviewing-2026-01-08-02-08-59-utc.jpg',
  clipboard:
    'https://cdn.magicpatterns.com/uploads/iWrjjXXKhV5MkB6wia5tfX/two-young-black-people-discuss-their-business-usin-2026-01-08-05-27-58-utc.jpg',
  logo: 'https://cdn.magicpatterns.com/uploads/sa6W2W8kYmxLvWxsb4HrNN/premier_advisory_logo.png',
}

export const processSteps = [
  {
    index: '01',
    title: 'Consultation & Discovery',
    description:
      'We sit with your finance team, review the books and the filings, and establish exactly where you stand before advising anything.',
  },
  {
    index: '02',
    title: 'Strategy Development',
    description:
      'We set out the compliance, reporting and structuring approach — scoped, costed and agreed with you in writing.',
  },
  {
    index: '03',
    title: 'Implementation & Execution',
    description:
      'We execute the engagement to professional standards, report clearly, and stay available for the questions that follow.',
  },
]

export const differentiators: string[] = [
  'Six advisory disciplines under one relationship — no handing you off to another firm.',
  'Deep sector fluency in tea factory companies, legal practices and donor-funded programmes.',
  'Three offices — Nairobi, Nanyuki and Nakuru — so partners are close to the work.',
  'Strict observation of ethical standards and professional due care on every engagement.',
]

export const team: TeamMember[] = [
  {
    name: 'Managing Partner',
    role: 'Firm leadership · Nairobi',
    photo: photos.reviewing,
  },
  {
    name: 'Tax Advisory Lead',
    role: 'Practice lead · Tax & compliance',
    photo: photos.clipboard,
  },
  {
    name: 'Audit & Assurance Lead',
    role: 'Practice lead · Audit',
    photo: photos.deskPair,
  },
  {
    name: 'Monitoring & Evaluation Lead',
    role: 'Practice lead · M&E',
    photo: photos.boardroom,
  },
]

export const faqs: Faq[] = [
  {
    question: 'What size of business do you work with?',
    answer:
      'From owner-managed SMEs and advocate practices through to tea factory companies, corporates and donor-funded programmes. The engagement is scoped to the size of the entity, not the other way round.',
  },
  {
    question: 'Can you act as our reporting accountants?',
    answer:
      'Yes. We handle bookkeeping, bank reconciliation, management accounts and full financial statements, and we can operate as your outsourced finance function alongside your internal team.',
  },
  {
    question: 'Do you handle KRA audits and disputes?',
    answer:
      'We do. That includes tax health checks before an issue arises, representation during tax audits and investigations, and correspondence and dispute resolution where a position needs to be defended.',
  },
  {
    question: 'Do you offer payroll services?',
    answer:
      'Yes — payroll processing as a bureau service, together with the statutory deductions and filings that go with it.',
  },
  {
    question: 'Which offices can we work with?',
    answer:
      'Our head office is in Westlands, Nairobi, with branch offices in Nanyuki and Nakuru. Engagements are staffed from the office closest to your operations.',
  },
  {
    question: 'How do we begin an engagement?',
    answer:
      'Start with a consultation. We review your current position, agree the scope and fee in writing, and only then begin work.',
  },
]

export const insights: Insight[] = [
  {
    tag: 'Tax Compliance',
    title: 'What a tax health check actually looks at',
    description:
      'A preventive review of filings, ledgers and positions taken — designed to surface exposure while it is still inexpensive to correct.',
  },
  {
    tag: 'Audit',
    title: 'Preparing your factory for a statutory audit',
    description:
      'The reconciliations, schedules and board papers worth assembling before fieldwork begins, so the audit runs to timetable.',
  },
  {
    tag: 'M&E',
    title: 'Baseline surveys that stand up to donor scrutiny',
    description:
      'How sampling, data collection discipline and clean database management determine whether your endline reporting holds.',
  },
]

export const heroStats = [
  { value: '11+', label: 'Years in practice' },
  { value: '20+', label: 'Institutions served' },
  { value: '3', label: 'Branches nationwide' },
  { value: '6', label: 'Service disciplines' },
]

export const recordStats = [
  { value: '2014', label: 'Founded in Nairobi' },
  { value: '20+', label: 'Companies & institutions served' },
  { value: '03', label: 'Branch offices' },
  { value: '06', label: 'Advisory disciplines' },
]

export const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Clients', href: '#clients' },
  { label: 'Team', href: '#team' },
  { label: 'FAQs', href: '#faqs' },
  { label: 'Contact', href: '#contact' },
]
